import Users from "./UserPage";

export default [
  { path: "/users", element: <Users /> }
];
